import { BaseModel } from '../models/base';

export const logError = (error: unknown): void => {
    // eslint-disable-next-line no-console
    console.error(error);
};

export const errorMessage = (error: unknown): string =>
    // eslint-disable-next-line unicorn/prefer-error-is-error -- Error.isError is not available in our TypeScript lib target
    error instanceof Error ? error.message : String(error);

export const sortByDate = (a: BaseModel, b: BaseModel): number => b.created_at.getTime() - a.created_at.getTime();

export function noop(): void {
    // do nothing
}

export function assert(value: unknown): asserts value {
    if (!value) {
        throw new TypeError('assertion failed');
    }
}
